import { useEffect, useState, useRef } from 'react';
import { IconCozTeam, IconCozWechatFill } from '@coze-arch/coze-design/icons';
import { Dropdown, Image, Modal, Form, Input } from '@coze-arch/coze-design';
import {
  getDeveloperUserpact,
  UserAgreePacts,
  saveDeveloperUserpact,
} from '@rokid/services';

export function ContactUsMenu() {
  return (
    <div>
      <Dropdown.Item
        icon={<IconCozTeam />}
        onClick={() => {
          location.href = 'https://forum.rokid.com/index';
        }}
      >
        开发者论坛
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item icon={<IconCozWechatFill />}>开发者小助理</Dropdown.Item>
      <p style={{ textAlign: 'center' }}>
        <Image
          src="https://custom.rokid.com/prod/rokid_oss/c35f3a4353f046fab7862999361ce3f8开发者小助理二维码.png"
          width={80}
        />
      </p>
    </div>
  );
}

//用户信息插件使用授权
interface AuthUserinfoPluginProps {
  title?: string;
  description?: string;
  visible: boolean;
  onCancel?: () => void;
  onOK?: (data: UserAgreePacts) => void;
}
export function AuthUserinfoPlugin(props: AuthUserinfoPluginProps) {
  const { visible, onCancel, title, description } = props;
  const formRef = useRef<Form>(null);
  const [initValue, setInitValue] = useState({
    userAgreementName: '',
    userAgreementUrl: '',
    privacyPolicyName: '',
    privacyPolicyUrl: '',
  });

  async function handleOK(values) {
    const res = await saveDeveloperUserpact(values);
    if (res) {
      props.onOK && props.onOK(values);
      onCancel?.();
    }
  }

  //每次进来都先查下当前用户的值，作为初始化信息
  useEffect(() => {
    getDeveloperUserpact().then(res => {
      if (res && res.id) {
        setInitValue(res);
      }
    });
  }, [visible]);
  return (
    <Modal
      title={title || '开发者自营应用隐私政策和用户协议'}
      visible={visible}
      onOk={() => {
        formRef.current?.formApi
          .validate()
          .then(handleOK)
          .catch(error => {
            console.log('验证失败', error);
          });
      }}
      onCancel={onCancel}
      cancelText="取消"
      okText="确定"
      width={840}
      okButtonProps={{ htmlType: 'submit' }}
    >
      <h5>
        {description ||
          '若当前智能体调用了‘Rokid账号信息获取插件’，为了确保开发者在使用插件时符合《个人信息保护法》及相关法律法规。需要开发者上传自营应用《用户协议》及《隐私政策》。'}
      </h5>
      <Form
        ref={formRef}
        layout="vertical"
        style={{ width: '100%' }}
        initValues={initValue}
      >
        <Form.InputGroup
          label={{ text: <span>用户协议</span>, required: true }}
          labelPosition="left"
        >
          <Form.Input
            field="userAgreementName"
            placeholder="协议名称"
            style={{ width: '200px' }}
            rules={[{ required: true, message: '请输入协议的名称' }]}
          />
          <Form.Input
            field="userAgreementUrl"
            placeholder="协议URL"
            style={{ width: '505px' }}
            rules={[{ required: true, message: '请输入协议URL' }]}
          />
        </Form.InputGroup>
        <Form.InputGroup
          label={{ text: <span>隐私政策</span>, required: true }}
          labelPosition="left"
        >
          <Form.Input
            field="privacyPolicyName"
            placeholder="隐私政策名称"
            style={{ width: '200px' }}
            rules={[{ required: true, message: '请输入隐私政策的名称' }]}
          />
          <Form.Input
            field="privacyPolicyUrl"
            placeholder="隐私政策URL"
            style={{ width: '505px' }}
            rules={[{ required: true, message: '请输入隐私政策URL' }]}
          />
        </Form.InputGroup>
      </Form>
    </Modal>
  );
}

export const useAuthUserinfoPluginModal = (props: {
  title?: string;
  description?: string;
  onOK?: (data: {
    userAgreementName: string;
    userAgreementUrl: string;
    privacyPolicyName: string;
    privacyPolicyUrl: string;
  }) => void;
}) => {
  const [visible, setVisible] = useState(false);
  return {
    visible,
    modalContent: (
      <>
        <AuthUserinfoPlugin
          visible={visible}
          onOK={props.onOK}
          onCancel={() => {
            setVisible(false);
          }}
          title={props.title}
          description={props.description}
        />
      </>
    ),
    open: () => setVisible(true),
    close: () => setVisible(false),
  };
};
